<div class="main-no-background flex f-fd--column f-gap--25px f-jc--center f-ai--center">
  <span></span>
  <span i18n="@@front-login.error-component.message">Error de inicio de sesión {{msg}}</span>
  <button mat-raised-button color="primary" (click)="goHome()" i18n="@@front-login.error-component.action">
    Ir a inicio
  </button>
</div>
